import { Button, Form, Input, Modal } from "antd";
import React, { useEffect } from "react";

function PerfCycleFilterModal(props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.visible) {
      props.filterBy?.cycleName &&
        form.setFields([
          { name: "cycleName", value: props.filterBy?.cycleName },
        ]);
    }
  }, [props.visible]);

  const onFinish = (values) => {
    props.handleOk(values);
    props.handleCancel();
    form.resetFields();
  };

  return (
    <Modal
      title="Filter Cycles"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Form
        name="filterCycles"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        form={form}
      >
        <Form.Item label="Cycle name" name="cycleName">
          <Input placeholder="Cycle name" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button className="w-28" type="primary" htmlType="submit">
              Filter
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default PerfCycleFilterModal;
